/* eslint-disable prefer-destructuring */
import { toSlug } from '@/utils/common';
import { pr } from '@/utils/pxToRem';
import { Stack, Link } from '@mui/material';
import React from 'react';
import AIRPORT_VN from '@/mappings/airport_vn.json';
import { genLinkSeo } from '@/utils/genLinkSeo';

interface SectionFamousToRouteProps {
  toPoint: any;
}

const SectionFamousToRoute: React.FC<SectionFamousToRouteProps> = ({
  toPoint,
}) => {
  const key = toPoint?.airports[0]?.airportCode;
  const listRoute = (AIRPORT_VN as any).routes[key];
  if (listRoute?.length > 10) {
    listRoute.length = 10;
  }
  return (
    <Stack
      spacing="16px"
      marginTop={pr`16px`}
    >
      {listRoute.map((airportCode: string) => {
        const areaData = AIRPORT_VN.airports.find((item) => item.AirportCode === airportCode);
        return (
          <Link
            sx={{ fontWeight: 500 }}
            // href={`/vn/ve-may-bay/tu-${toSlug(areaData?.CityName_Vi || '')}-di-${toSlug(toPoint.location)}.${areaData?.VxrAreaParentId}.${toPoint.id}.vi`}
            // href={genLinkSeo('', areaData.CityName_Vi, areaData?.stateName, areaData.VxrAreaParentId, toPoint?.location, toPoint?.stateName, toPoint?.id)}
            href={genLinkSeo({
              startName: areaData?.CityName_Vi,
              startId: areaData?.VxrAreaParentId,
              startStateName: areaData?.stateName,
              endName: toPoint?.location,
              endId: +(toPoint?.id || 0),
              endStateName: toPoint?.stateName,
            })}
            key={airportCode}
          >
            {` Vé máy bay giá rẻ từ
            ${areaData?.CityName_Vi}
            đi 
            ${toPoint.location}
            `}
          </Link>
        );
      })}
    </Stack>
  );
};

export default SectionFamousToRoute;
